import request from 'graphql-request';
import { getMenus } from '@lib/menus';
// import { getThemeAssets } from '@lib/themeAssets';
// import { getClientStories } from '@lib/pages';
import GET_CLIENTSTORY from '@lib/queries/GET_CLIENTSTORY';
import ClientStoryLayout from '@layouts/clientStories';
import GET_CLIENTSTORIES from '@lib/queries/GET_CLIENTSTORIES';
import { renderGutenbergBlocks } from '@util/blocks';
import { getDefaults } from '@lib/defaults';
import { getThemeAssets } from '@lib/themeAssets';

export default function ClientStories(props) {
    let blocks = props.blocks;
    return (
        <ClientStoryLayout pageProps={props}>
            {renderGutenbergBlocks(blocks, props)}
        </ClientStoryLayout>
    );
}

export async function getStaticPaths(context) {
    const results = await request(
        process.env.GRAPHQL_ENDPOINT,
        GET_CLIENTSTORIES
    );

    const paths = results.clientstories.edges.map((page) => `${page.node.uri}`);

    return { paths, fallback: false };
}

export async function getStaticProps(context) {
    let { slug = '/' } = context.params;



    const pageData = await request(
        process.env.GRAPHQL_ENDPOINT,
        GET_CLIENTSTORY,
        {
            id: `/clientstories/${slug[0]}`
        }
    );

    const {
        title,
        blocks,
        blocksJSON,
        contentType: {
            node: { name: contentType }
        },
        acf_post_event,
        seo,
        date = '',
        link = '',
        relatedPosts,
        categories
    } = pageData.contentNode;
    const menus = {};
    getMenus(pageData).map((menu) => (menus[menu.slug] = menu));
    let options = pageData.options.acf_site_options;
    let defaults = getDefaults(pageData);

    const themeAssets = {};
    getThemeAssets(pageData).map(
        (item) => (themeAssets[item.id] = item.acf_post_type_theme_assets)
    );

    const nextSeoProps = {
        canonical:
            'https://' +
            process.env.NEXT_PUBLIC_SITE_DOMAIN +
            `/clientstories/${slug[0]}/`,
        openGraph: {},
        title: `${title} - Enfusion`
    };


    const props = {
        title,
        link,
        blocks,
        menus,
        options,
        relatedPosts,
        contentType,
        themeAssets,
        nextSeoProps,
        categories: pageData?.contentNode?.categories || [],
        defaults,
        layoutType: pageData?.contentNode?.postFields?.layoutType || 'default',
        mediaContactHide:
            pageData?.contentNode?.postFields?.mediaContactHide || '0',
        mediaContact:
            pageData?.contentNode?.mediaContact?.mediaContactSettings || {},
        optionHideCta:
            pageData?.contentNode?.optionHideCta?.hideCtaModule || '0',
        useNewDesign:
            pageData?.contentNode?.optionHideCta?.useNewDesign || '0',
        displayCareerCta: pageData?.contentNode?.careerCta?.displayCareerCta || '0',
        acf_post_event: pageData?.contentNode?.acf_post_event || [],
        date,
        seo,
        perPageFields: pageData?.contentNode?.perPageFields || null,
        acf_page_layout: pageData?.contentNode?.acf_page_layout || null,
        acf_client_meta: pageData?.contentNode?.acf_client_meta || null,
    };

    return {
        props: props
    };
}